<template>
    <div>
        <el-dialog title="修改课程" width="600px" class="icon-dialog" :visible.sync="show" @open="open"
            :before-close="closeForm" append-to-body>
            <el-form :size="size" ref="form" :model="form" :inline="true">
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="课程标题" prop="title">
                            <el-input v-model="form.title" autoComplete="off" clearable placeholder="请输入课程标题"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item label="课程类型">
                    <el-select style="width: 215px;" size="small" v-model="form.cate_type" placeholder="请选择">
                        <el-option v-for="type in apidlist" :label="type.key" :value="type.value"
                            :key="type.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="题目数量" prop="nums">
                            <el-input v-model="form.nums" autoComplete="off" type="number" placeholder="请输入题目数量"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="课程排序" prop="sort">
                            <el-input v-model="form.sort" type="number" autoComplete="off" placeholder="请输入课程排序"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item label="内容类型">
                    <el-select @visible-change="vchange"  @change="sechange" style="width: 215px;" size="small" v-model="form.fulfillment_type" placeholder="请选择">
                        <el-option v-for="type in types" :label="type.key" :value="type.value"
                            :key="type.value"></el-option>
                    </el-select>
                </el-form-item>
                <div v-if="form.fulfillment_type == 4 || form.fulfillment_type == 6">
                    <quill-editor ref="text" v-model="form.contents" class="editor" :options="editorOption" />
                </div>
                <div v-else>
                    <div style="display: flex;">
                        <el-form-item label="课程内容" prop="contents">
                            <el-input v-model="form.contents" autoComplete="off" clearable placeholder="请上传课程内容"></el-input>
                        </el-form-item>
                        <el-upload class="avatar-uploader" :action="updatehttp" :headers="headers" :data="updata"
                            accept=".jpg, .jpeg, .png, .gif, .bmp, .JPG, .JPEG, .PBG, .GIF, .BMP" :show-file-list="false"
                            :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
                            <el-button size="small" type="primary" :loading="loading1">
                                <span v-if="!loading1">点击上传</span>
                                <span v-else>上传中...</span>
                            </el-button>
                        </el-upload>
                    </div>
                </div>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button :size="size" :loading="loading" type="primary" @click="submit">
                    <span v-if="!loading">确 定</span>
                    <span v-else>提 交 中...</span>
                </el-button>
                <el-button :size="size" @click="closeForm">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { getCourSet } from '../../api/userMG';
import '../../assets/css/quillEditor.css';
//引入Qill插件
import Quill from "quill";
// 自定义字体
let fontFamily = ['宋体', '黑体', '微软雅黑', '楷体', '仿宋', 'Arial', '苹方'];
Quill.imports['attributors/style/font'].whitelist = fontFamily;
Quill.register(Quill.imports['attributors/style/font']);

// 自定义文字大小
let fontSize = ['10px', '12px', '14px', '16px', '20px', '24px', '36px']
Quill.imports['attributors/style/size'].whitelist = fontSize;
Quill.register(Quill.imports['attributors/style/size']);

// 新增行高
let Parchment = Quill.import("parchment");
let lingHeight = ['initial', '1', '1.5', '1.75', '2', '3', '4'];
class lineHeightAttributor extends Parchment.Attributor.Style { }
const lineHeightStyle = new lineHeightAttributor("lineHeight", "line-height", {
    scope: Parchment.Scope.INLINE,
    whitelist: lingHeight
});
Quill.register({ "formats/lineHeight": lineHeightStyle }, true);

// 对齐方式样式都改成style方式，而不是class
let Align = Quill.import('attributors/style/align');
Align.whitelist = ['right', 'center', 'justify'];
Quill.register(Align, true);

const toolbarOptions = [
    [
        "bold",
        "italic",
        "underline",
        "strike",
        "blockquote",
        "code-block",
        { header: 1 },
        { header: 2 },
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
        { script: "sub" }, // 下标
        { script: "super" }, // 上标
        { align: [] },
        { color: [] },
        { background: [] },
        "link",
        "image",
    ],
    [{ size: fontSize }], // 文字大小
    [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题
    [{ font: fontFamily }], // 字体
    [{ lineheight: lingHeight }]   // 行高
];
export default {
    name: 'Add',
    components: {
    },
    props: {
        show: {
            type: Boolean,
            default: false
        },
        size: {
            type: String,
            default: 'small'
        },
        info: {
            type: Object
        }
    },
    data() {
        return {
            updata: {},
            updatehttp: '/lecturer/putFile',
            headers: {
                token: localStorage.getItem('logintoken')
            },
            apidlist: [
                { key: '请选择', value: '' },
                { key: '题目', value: 0 },
                { key: '图片', value: 1 },
                { key: '视频', value: 2 },
            ],
            types: [
                { key: '请选择', value: '' },
                { key: '视频', value: 1 },
                { key: '音频', value: 2 },
                { key: '图片', value: 3 },
                { key: '文字', value: 4 },
                { key: '富文本', value: 6 },

            ],
            form: {
                cid: '',
                title: '',
                nums: '',
                cate_type: '',
                contents: '',
                fulfillment_type: '',
                sort: ''
            },
            editorOption: {
                modules: {
                    toolbar: {
                        container: toolbarOptions,
                        handlers: {
                            lineheight: function (value) {
                                if (value) {
                                    this.quill.format('lineHeight', value);
                                } else {
                                    console.log(value);
                                }
                            },
                        },
                    }
                },
            },
            loading: false,
            loading1: false,
            rules: {
            },
            updata: {
                file_name: 0
            },
            setype:''
        }
    },
    created() {
        this.userinfo = JSON.parse(localStorage.getItem('userdata'))
        console.log(this.userinfo.Permissions_type);
    },
    methods: {
        vchange(e){
            this.setype = this.form.fulfillment_type
        },
        sechange(e){
            console.log(this.setype == e);
            if(this.setype == e){ return;}
            this.form.contents = ''
        },
        handleAvatarSuccess(res, file) {
            console.log(res.img_url);
            this.form.contents = res.img_url
            this.loading1 = false
        },
        beforeAvatarUpload() {
            this.loading1 = true
        },
        open() {
            this.form = this.info
        },
        submit() {
            console.log(this.form);
            this.$refs['form'].validate(valid => {
                if (valid) {
                    this.loading = true
                    this.form.echo = 'set'
                    getCourSet(this.form).then(res => {
                        console.log(res.code);
                        if (res.code == 200) {
                            this.$message({ message: '操作成功', type: 'success' })
                            this.$emit('refesh_list')
                            this.closeForm()
                        } else {
                            this.$message({ message: res.msg, type: 'error' })
                            this.loading = false
                        }
                    }).catch(() => {
                        this.loading = false
                    })
                }
            })
        },
        closeForm() {
            this.$emit('update:show', false)
            this.loading = false
            this.form = {}
            this.type = ''
            if (this.$refs['form'] !== undefined) {
                this.$refs['form'].resetFields()
            }
        },
    }
}
</script>
<style scoped >
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
    border: 1px solid #dadcdf;
    margin-top: 10px;
    border-radius: 10px;
}

.avatar {
    width: 100px;
    height: 100px;
    display: block;
    border: 1px solid #dadcdf;
}

.avatar1 {
    width: 200px;
    height: 300px;
    display: block;
    border: 1px solid #dadcdf;
}

.avatar-uploader-icon1 {
    font-size: 28px;
    color: #8c939d;
    width: 200px;
    height: 300px;
    line-height: 300px;
    text-align: center;
    border: 1px solid #dadcdf;
    margin-top: 10px;
    border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/course/updatedetails.vue